'use client'

import type { ReactNode } from 'react'
import { Link } from '@/i18n/navigation'
import Image from 'next/image'
import { Footer, MarketingNav } from '@/components/marketing'
import { LocaleAccessGate } from '@/components/i18n/LocaleAccessGate'
import { Providers } from '../../providers'

export default function MarketingLayout({ children }: { children: ReactNode }) {
  return (
    <Providers>
      <LocaleAccessGate>
        <div className="flex min-h-screen scroll-smooth flex-col bg-black text-white">
          {/* Mobile Navbar Background */}
          <div className="pointer-events-none fixed start-0 end-0 top-0 z-40 h-20 bg-black/40 backdrop-blur-md lg:hidden" />

          {/* Logo - Fixed top left */}
          <Link href="/" className="group fixed start-6 top-6 z-50 md:start-8">
            <div className="flex h-9 w-28 items-center justify-center transition-transform duration-300 group-hover:scale-110 md:h-10 md:w-32">
              <Image
                src="/marketing/martini-logo.png"
                alt="Martini Logo"
                width={128}
                height={40}
                className="h-9 w-auto transition-opacity duration-300 md:h-10"
                priority
              />
            </div>
          </Link>

          {/* Navigation */}
          <MarketingNav />

          {/* Main Content */}
          <main className="flex flex-1 flex-col">{children}</main>

          {/* Footer */}
          <Footer />
        </div>
      </LocaleAccessGate>
    </Providers>
  )
}
